import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { motion } from "framer-motion";
import { DEFAULT_MOTION_PROPS, fadeInMotion, } from "../../constants/motions.constants.js";
const PageContent = ({ banner, children, className, isWidget, }) => {
    if (Boolean(banner) && !isWidget) {
        return (_jsxs("div", { className: "pb-10 pt-48 lg:pt-44", children: [_jsx("div", { className: "absolute left-0 right-0 top-[5rem] lg:top-[5.5rem]", children: banner }), _jsx("div", { className: className, children: children })] }));
    }
    if (Boolean(banner) && isWidget) {
        return (_jsxs("div", { className: "pb-16 pt-52", children: [_jsx("div", { className: "absolute left-0 right-0 top-[5rem] lg:top-[5.5rem]", children: banner }), _jsx("div", { className: className, children: children })] }));
    }
    return _jsx("div", { className: className, children: children });
};
export const AnimatedPageContent = ({ children, ...props }) => {
    return (_jsx(motion.section, { ...DEFAULT_MOTION_PROPS, variants: fadeInMotion, children: _jsx(PageContent, { ...props, children: children }) }));
};
export default AnimatedPageContent;
//# sourceMappingURL=PageContent.js.map